import {getEventTicketLimitPerOrder, shouldTicketLimitTooltipShow} from '@wix/wix-events-commons-statics'
import {SectionNotification} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useAppSelector} from '../../../../../hooks/runtime'
import {getEvent} from '../../../../../selectors/event'
import {getSelectedTicketQuantity, getSelectedTicketsQuantity} from '../../../../../selectors/selected-tickets'
import {classes} from './limit-reached-notification.st.css'

export const LimitReachedNotification = ({
  ticket,
  className,
}: {
  ticket: wix.events.ticketing.TicketDefinition
  className?: string
}) => {
  const {t} = useTranslation()
  const event = useAppSelector(getEvent)
  const maxTicketsPerReservation = getEventTicketLimitPerOrder(event)
  const selectedQuantity = useAppSelector(state => getSelectedTicketQuantity(state, ticket.id))
  const allSelectedTicketsQuantity = useAppSelector(state => getSelectedTicketsQuantity(state))
  const availableTicketsQuantity = maxTicketsPerReservation - allSelectedTicketsQuantity
  const show = shouldTicketLimitTooltipShow(availableTicketsQuantity, selectedQuantity)

  if (!show) {
    return null
  }

  return (
    <SectionNotification className={classNames(classes.root, className)} type="wired" size="compact">
      <SectionNotification.Text>
        {t('ticketLimitPerReservationReachedNotification', {count: maxTicketsPerReservation})}
      </SectionNotification.Text>
    </SectionNotification>
  )
}
